module.exports = __webpack_public_path__ + "static/media/qlc.c1056adb.svg";